module.exports = __webpack_public_path__ + "img/V12.0e93305f.jpg";